import { Fragment } from "react";
import { Navigate, NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { List } from "./list";
import { Button } from "@progress/kendo-react-buttons";
import { formatDateTime } from "../lib/utils";
import { loadEntity } from "../redux/slices/scheduleviewpageslice";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const connectionItemRenderer = (currentTheme, t) => (props, item, index) => {
  return (
    <div
      key={item.ConnectionId}
      className={`list-item`}
      onDoubleClick={(e) => props.onEdit(item)}
    >
      <div className="list-item-title" style={{ fontWeight: `400` }}>
        <div className="list-detail-title" style={{ width: "30%" }}>
          <span className="connection-mobile-field-label">{t("connection.title")}</span>
          {item.ConnectionTitle}
        </div>
        <div className="list-detail-title" style={{ width: "27%" }}>
          <span className="connection-mobile-field-label">{t("connection.connector")}</span>
          {item.ConnectorName}
        </div>
        <div className="list-detail-title">
          <span className="connection-mobile-field-label">{t("connection.account")}</span>
          {item.AccountIdentifier}
        </div>
      </div>

      <div className="list-item-view list-item-action">
        {props.canView && (
          <Button
            disabled={false}
            title={t("connection.view")}
            style={{
              border: "none",
              color: currentTheme.touchColor,
              backgroundColor: "transparent",
            }}
            icon="eye"
            onClick={(e) => props.onEdit(item)}
          ></Button>
        )}
      </div>

      <div className="list-item-edit list-item-action">
        {props.canEdit && ( //!isClient &&
          <Button
            disabled={false}
            title={t("connection.edit")}
            style={{
              border: "none",
              color: currentTheme.touchColor,
              backgroundColor: "transparent",
            }}
            icon="edit"
            onClick={(e) => props.onEdit(item)}
          ></Button>
        )}
      </div>

      <div className="list-item-delete list-item-action">
        {props.canDelete && (
          <Button
            disabled={false}
            title={t("connection.delete")}
            style={{
              border: "none",
              color: currentTheme.error,
              backgroundColor: "transparent",
            }}
            icon="delete"
            onClick={(e) => props.onDelete(item.ConnectionId)}
          ></Button>
        )}
      </div>
    </div>
  );
};

export const ConnectionViewer = (props) => {
  const {
    canView,
    canCreate,
    canEdit,
    canDelete,
    onDelete,
    onImport,
    onEdit,
    onSetFavorite,
    ...other
  } = props;

  const currentTheme = useSelector((state) => state.currentTheme);
  const pageState = useSelector((state) => state.connectionLocatorPage);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const filter = pageState.filter;
  const showSystemEntities = pageState.showSystemEntities;

  const filteredItems = pageState.items.filter((e) => {
    if ((!filter || filter.trim() == "") && showSystemEntities) return true;

    if (!filter || filter.trim() == "")
      //do not show system entities
      return e.IsSystem == false;

    //i am here => there is text
    const trimmedFilter = filter.toLowerCase();
    const matchesFilter = [
      e.ConnectionTitle,
      e.Title,
      e.ConnectorName,
      e.AccountIdentifier,
    ].some((value) => value?.toLowerCase().includes(trimmedFilter));

    if (showSystemEntities)
      return matchesFilter;

    return matchesFilter && e.IsSystem == false;
  });

  return (
    <Fragment>
      <div className={"connection-viewer"}>
        <div className="header-list">
          <div className="header-left" style={{ width: "30%" }}>
            {t("connection.title")}
          </div>
          <div className="header-center" style={{ width: "30%" }}>
            {t("connection.connector")}
          </div>
          <div className="header-right">{t("connection.account")}</div>
        </div>
        {filteredItems?.length > 0 && (
          <List
            className="connection-viewer-list"
            navigate={navigate}
            items={filteredItems}
            onSetFavorite={onSetFavorite}
            canView={canView}
            canCreate={canCreate}
            canEdit={canEdit}
            canDelete={canDelete}
            onDelete={onDelete}
            onEdit={onEdit}
            itemRenderer={connectionItemRenderer(currentTheme, t)}
          />
        )}
      </div>
      <style>
        {`
                    .connection-viewer
                    {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;
                        align-items: flex-start;
                        align-content: start;
                        flex: 1;
                        overflow: auto;
                        padding: 8px 26px;
                    }
                        
                    .connection-viewer .header-list{
                      display:flex;
                      width:calc(100% - 130px);
                      padding:12px;
                      font-weight:bold;
                    }

                    .connectionlocator-page .connection-viewer .connection-viewer-list
                    {
                        border: 1px dotted ${currentTheme.separatorColor}; 
                        border-radius: 8px;
                        min-width: 700px;
                        width: 100%;
                        height: calc(100% - 130px);
                        display:table;
                        padding: 0px 0px 0px 0px;
                        overflow-y:auto;
                    }

                    .connectionlocator-page .connection-viewer .connection-viewer-list .list-root
                    {
                        border-collapse: collapse;
                    }

                    .connectionlocator-page .connection-viewer .connection-viewer-list .list-item
                    {
                        line-height: 3;
                        border-top: 1px solid ${currentTheme.componentBorderColor}; 
                        border-radius: 6px;
                    }

                    .connectionlocator-page .connection-viewer .connection-viewer-list .list-item:first-child
                    {
                        border-top: none;
                    }

                    .connectionlocator-page .connection-viewer .connection-viewer-list .list-item:last-child
                    {
                        border-bottom: 1px solid ${currentTheme.componentBorderColor}; 
                    }

                    .connectionlocator-page .connection-viewer .connection-viewer-list .list-item:hover
                    {
                      background-color: ${currentTheme.componentBorderColor};
                      cursor: pointer;
                    }

                    .connectionlocator-page .connection-viewer .connection-viewer-list .list-item-title,
                    .connectionlocator-page .connection-viewer .connection-viewer-list .list-item-system
                    {
                        width: 100%;
                        vertical-align: middle;
                        padding-left: 12px;
                        display:flex;
                    }

                    .connectionlocator-page .connection-viewer .connection-viewer-list .list-item-action{
                        width:30px;
                    }

                    .connection-mobile-field-label {
                      display: none;
                    }

                    @media (max-width: 1024px) {
                      .connectionlocator-mobile-view .connection-viewer {
                        height: auto;
                        padding: 0;
                        overflow: visible;
                      }

                      .connectionlocator-mobile-view .connection-viewer .header-list {
                        display: none;
                      }

                      .connectionlocator-mobile-view .connection-viewer .connection-viewer-list {
                        min-width: 0;
                        height: auto;
                        border: none;
                        border-radius: 0;
                        display: block;
                        overflow: visible;
                      }

                      .connectionlocator-mobile-view .connection-viewer .connection-viewer-list .list-root {
                        display: block;
                      }

                      .connectionlocator-mobile-view .connection-viewer .connection-viewer-list .list-item {
                        display: flex;
                        align-items: flex-start;
                        padding: 12px 0;
                        border-top: none;
                        border-bottom: 1px solid ${currentTheme.separatorColor};
                        line-height: normal;
                      }

                      .connectionlocator-mobile-view .connection-viewer .connection-viewer-list .list-item > div {
                        display: flex;
                        padding: 0;
                      }

                      .connectionlocator-mobile-view .connection-viewer .connection-viewer-list .list-item-title {
                        flex: 1;
                        min-width: 0;
                        flex-direction: column;
                        gap: 6px;
                      }

                      .connectionlocator-mobile-view .connection-viewer .connection-viewer-list .list-detail-title {
                        display: flex;
                        flex-direction: column;
                        width: 100% !important;
                        overflow-wrap: anywhere;
                      }

                      .connectionlocator-mobile-view .connection-viewer .connection-viewer-list .list-detail-title:first-child {
                        font-size: 14px;
                        font-weight: 600;
                      }

                      .connectionlocator-mobile-view .connection-mobile-field-label {
                        display: block;
                        margin-bottom: 2px;
                        font-size: 11px;
                        color: ${currentTheme.inputLabelColor};
                      }

                      .connectionlocator-mobile-view .connection-viewer .connection-viewer-list .list-item-action {
                        flex: 0 0 auto;
                        width: auto;
                        margin-inline-start: 4px;
                      }

                      .connectionlocator-mobile-view .connection-viewer .connection-viewer-list .list-item-edit,
                      .connectionlocator-mobile-view .connection-viewer .connection-viewer-list .list-item-delete {
                        display: none !important;
                      }
                    }
                    
                    `}
      </style>
    </Fragment>
  );
};
